import { render } from "./Block.vue?vue&type=template&id=0fafdc0e&scoped=true"
import script from "./Block.vue?vue&type=script&lang=js"
export * from "./Block.vue?vue&type=script&lang=js"

import "./Block.vue?vue&type=style&index=0&id=0fafdc0e&lang=scss"
import "./Block.vue?vue&type=style&index=1&id=0fafdc0e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fafdc0e"]])

export default __exports__